function handleLocationError(idMappa) {
    //centro su Genova
    var mapOptions = {
        center: new google.maps.LatLng(44.4471368, 8.7504059),
        zoom: 10,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    map = new google.maps.Map(document.getElementById(idMappa), mapOptions);
}








//function bootstrapModal(){
//    <div class="modal fade" tabindex="-1" role="dialog">
//  <div class="modal-dialog" role="document">
//    <div class="modal-content">
//      <div class="modal-header">
//        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
//        <h4 class="modal-title">Modal title</h4>
//      </div>
//      <div class="modal-body">
//        <p>One fine body&hellip;</p>
//      </div>
//      <div class="modal-footer">
//        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
//        <button type="button" class="btn btn-primary">Save changes</button>
//      </div>
//    </div><!-- /.modal-content -->
//  </div><!-- /.modal-dialog -->
//</div><!-- /.modal -->
//}

/**
 * Crea e apre una modale alla chiusura viene eliminata
 * 
 * @param {type} placement
 * @param {type} heading
 * @param {type} body
 * @param {type} footer
 * @returns {undefined}
 */
function doModal(placement, heading, body, footer) {

    footer = typeof footer !== 'undefined' ? footer : '<button type="button" class="btn btn-default" data-dismiss="modal">Chiudi</button>';


    var modal = '<div class="modal fade" id="modal-window" tabindex="-1" role="dialog">' +
                    '<div class="modal-dialog" role="document">' +
                        '<div class="modal-content">' +
                            '<div class="modal-header">' +
                            '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
                            '<h4 class="modal-title">' + heading + '</h4>' +
                            '</div>' +
                            '<div class="modal-body">' + body + '</div>' +
                            '<div class="modal-footer">' + footer + '</div>' +
                        '</div><!-- /.modal-content -->' +
                    '</div><!-- /.modal-dialog -->' +
                '</div><!-- /.modal -->';


    $(placement).append(modal);
    $("#modal-window").modal('show');

    $("#modal-window").on('hidden.bs.modal', function (e) {
        var element = document.getElementById("modal-window");
        element.parentNode.removeChild(element);
    });
}
/**
 * Crea la tabella degli annunci
 * 
 * @param {type} markers
 * @returns {String}
 */
function annunciTable(markers) {
    var html = '<table class="table">';

    for (j = 0; j < markers.annunci.length; j++) {
        html +=
                '<tr>' +
                '<td><strong><a href="' + markers.annunci[j].idAnnuncio + '" target="_blank">' + markers.annunci[j].titoloAnnuncio + '</a></strong></td>' +
                '<td>' + (markers.annunci[j].tipologiaAnnuncio) + '</td>' +
                '<td>' + (markers.annunci[j].dataAnnuncio) + '</td>' +
                '</tr>';
    }

    html += '</table>';

    return html;
}


function drawMarkerIndirizzi(map, markers, showAnnunci, infoWindow) {

    var infoContent;
    if (infoWindow == null) {
        infoWindow = new google.maps.InfoWindow();
    }

    if (markers.length == 0) {
        return;
    }

    var first = markers.annunci[0];
    var marker = drawMarkerCommon(map, first.latitudine, first.longitudine, "https://maps.google.com/mapfiles/ms/micons/yellow-dot.png");

    google.maps.event.addListener(marker, 'click', (function (marker, i) {

        windowWidth = $(window).width();

        if (windowWidth >= 768) {
            return function () {

                infoContent =
                        '<div class="info_content">' +
                        '<h6>Indirizzo personale</h6>' +
                        '<h3>' + (first.indirizzoPubblico) + '</h3>';
                        

                if (showAnnunci) {
                    infoContent += annunciTable(markers);
                }
                infoContent +=
                        '</div>';

                infoWindow.setContent(infoContent);
                infoWindow.open(map, marker);

            };
        } else {
            return function () {
                doModal('body', '<h6  class="modal-title"><small>Indirizzo personale</small></h6>' + first.indirizzoPubblico , annunciTable(markers));
            };
        }

    })(marker, i));

    return marker;
}

function drawMarkerLocalita(map, markers, showAnnunci, infoWindow) {

    var infoContent;
    if (infoWindow == null) {
        infoWindow = new google.maps.InfoWindow();
    }

    if (markers.length == 0) {
        return;
    }

    var first = markers.annunci[0];
    var marker = drawMarkerCommon(map, first.latitudine, first.longitudine, "https://maps.google.com/mapfiles/ms/micons/green-dot.png");

    google.maps.event.addListener(marker, 'click', (function (marker, i) {


        windowWidth = $(window).width();

        if (windowWidth >= 768) {
            return function () {

                infoContent =
                        '<div class="info_content">' +
                        '<h6>Localit&agrave;</h6>' + 
                        '<h3>' + (first.indirizzoPubblico) + '</h3>';

                if (showAnnunci) {
                    infoContent += annunciTable(markers);
                }
                infoContent +=
                        '</div>';

                infoWindow.setContent(infoContent);
                infoWindow.open(map, marker);

            };
        } else {
            return function () {
                doModal('body', '<h6  class="modal-title"><small>Localit&agrave;</small></h6>' + first.indirizzoPubblico , annunciTable(markers));
            };
        }

    })(marker, i));

    return marker;
}

function drawMarkerGcp(map, markers, showAnnunci, infoWindow) {

    var infoContent;
    if (infoWindow == null) {
        infoWindow = new google.maps.InfoWindow();
    }

    if (markers.length == 0) {
        return;
    }

    var first = markers.annunci[0];
    var marker = drawMarkerCommon(map, first.latitudine, first.longitudine, "https://maps.google.com/mapfiles/ms/micons/blue-dot.png");

    var url_regolamento = "https://www.toorna.it/regolamento-punti-toornaqui/";

    google.maps.event.addListener(marker, 'click', (function (marker, i) {
        
        
        windowWidth = $(window).width();

        if (windowWidth >= 768) {
            return function () {

                infoContent =
                    '<div class="info_content">' +
                    '<h6>Punto ToornaQui</h6>' +
                    '<h3>' + (first.titolo) + '</h3>' +
                    '<p>' + (first.indirizzoPubblico) + '</p>' +
                    '<p><a href="' + (first.url) + '">dettagli</a> | <a href="' + (url_regolamento) + '" target="_blank">regolamento Punti ToornaQui</a></p>';

                if (showAnnunci) {
                    infoContent += annunciTable(markers);
                }
                infoContent +=
                        '</div>';

                infoWindow.setContent(infoContent);
                infoWindow.open(map, marker);

            };
        } else {
            return function () {
                var body =  '<p>' + (first.indirizzoPubblico) + '</p>' +
                            '<p><a href="' + (first.url) + '">Dettagli</a> | <a href="' + (url_regolamento) + '" target="_blank">regolamento Punti ToornaQui</a></p>';
                
                doModal('body', '<h6 class="modal-title"><small>Punto ToornaQui</small></h6>' + first.titolo , body );
            };
        }

    })(marker, i));

    return marker;
}

function drawMarkerCommon(map, latitudine, longitudine, icon) {
    var pos = new google.maps.LatLng(latitudine, longitudine);

    var marker = new google.maps.Marker({
        position: pos,
        map: map,
        icon: icon
    });

    google.maps.event.addListener(marker, 'rightclick', (function (marker, i) {//cliccando con il tasto destro zooma sul testo della mappa
        return function ()
        {
            map.setZoom(17);
            map.panTo(this.getPosition());
        };
    })(marker, i));

    return marker;
}

function addLegend(map, $mapDiv) {
    $mapDiv.after('<div id="legend" class="hidden-xs kleo-child-legend"><h3>Legenda</h3></div>');
    $mapDiv.after('<div id="legendMobile" class="visible-xs kleo-child-legend"><h3>Legenda</h3></div>');

    $("#legend, #legendMobile").append("<div><img src='https://maps.google.com/mapfiles/ms/micons/yellow-dot.png'> Indirizzo personale</div>");
    $("#legend, #legendMobile").append("<div><img src='https://maps.google.com/mapfiles/ms/micons/green-dot.png' > Localit&agrave;</div>");
    $("#legend, #legendMobile").append("<div><img src='https://maps.google.com/mapfiles/ms/micons/blue-dot.png'  > Punto ToornaQui</div>");

    map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(legend);
}